<template>
	<node-view-wrapper class="data-chip-adapter">
		<!-- deleteNode comes from nodeViewProps -->
		<DataChip :contentObj="contentObj" :selected="selected" @autofill-rejected="deleteNode" />
	</node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';
import { b64DecodeUnicode } from '@/components/common/RichTextBox/DataChip/base64-unicode-utils.js';

import DataChip from './DataChip';

export default {
	name: 'DataChipAdapter',
	components: {
		NodeViewWrapper,
		DataChip,
	},
	props: nodeViewProps,
	computed: {
		contentObj() {
			try {
				return JSON.parse(b64DecodeUnicode(this.node.attrs.content)); // We convert to base64 in replaceAllDelimitedDataToTipTapFormat, so here we decode it
			} catch (err) {
				console.error(err);
				console.error(this.node.attrs.content);
				throw err;
			}
		},
	},
};
</script>

<style scoped lang="scss">
.data-chip-adapter {
	display: inline-block;
}
</style>
